import React, { useState, useEffect } from "react";
import "./portfolio.css";
import Menu from "./Menu";
import SimpleOptimizedImage from "../common/SimpleOptimizedImage";
import {
  FaGithub,
  FaExternalLinkAlt,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";

const ProjectCard = ({ project }) => {
  const [expanded, setExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Show only first item on mobile when not expanded
  const visibleDescription =
    isMobile && !expanded
      ? project.description.slice(0, 1)
      : project.description;

  return (
    <article className="portfolio__item">
      <div className="portfolio__item-image">
        <SimpleOptimizedImage 
          src={project.image} 
          alt={`${project.title} - ${project.subtitle}`}
        />
      </div>
      <div className="portfolio__item-content">
        <h3>{project.title}</h3>
        <h4>{project.subtitle}</h4>

        <div className="portfolio__item-description">
          <ul>
            {visibleDescription.map((bullet, index) => (
              <li key={index}>{bullet}</li>
            ))}
          </ul>

          {isMobile && project.description.length > 1 && (
            <button
              className="description-toggle"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? (
                <>
                  Show Less <FaChevronUp />
                </>
              ) : (
                <>
                  Read More <FaChevronDown />
                </>
              )}
            </button>
          )}
        </div>

        <div className="portfolio__item-tech">
          {project.technologies.map((tech, index) => (
            <span key={index} className="tech-tag">
              {tech}
            </span>
          ))}
        </div>

        <div className="portfolio__item-cta">
          {project.href && project.href !== "" && (
            <a
              href={project.href}
              className="portfolio__btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaExternalLinkAlt /> Live Demo
            </a>
          )}
          {project.github && project.github !== "" && (
            <a
              href={project.github}
              className="portfolio__btn portfolio__btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGithub /> Source Code
            </a>
          )}
        </div>
      </div>
    </article>
  );
};

const Portfolio = () => {
  const [items] = useState(Menu);

  return (
    <section className="work container section" id="portfolio">
      <h2 className="section__title">Latest Projects</h2>

      <div className="work__container grid">
        {items.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
